import { Ability, AbilityClass } from '@casl/ability';

export type Action = 'view' | 'edit' | 'manage';

export type AppAbility = Ability<[Action, string]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
